import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { ContainerView } from './container_view';
export const ResourcesPreview = ({ messages, sortIndex }) => {
    const containerRef = useRef(null);
    useEffect(() => {
        if (typeof window === 'undefined') {
            return;
        } // Only run in browser
        const container = containerRef.current;
        if (!container) {
            return;
        }
        const anchors = container.querySelectorAll('a');
        anchors.forEach((anchor) => {
            const href = anchor.getAttribute('href') || '';
            if (!/^https?:\/\//i.test(href)) {
                anchor.setAttribute('href', `https://${href}`);
            }
            anchor.setAttribute('target', '_blank');
            anchor.setAttribute('rel', 'noopener noreferrer');
        });
    }, [messages]);
    if (!messages) {
        return null;
    }
    return [
        _jsxs(ContainerView, { children: [_jsx("style", { children: `
          .resources-preview a{
            color: revert; 
            text-decoration: revert;
          }
        ` }), _jsx("div", { ref: containerRef, style: { padding: '2rem', wordBreak: 'break-word' }, className: 'resources-preview', children: Object.keys(messages)
                        .sort((a, b) => { var _a, _b; return ((_a = sortIndex === null || sortIndex === void 0 ? void 0 : sortIndex[a]) !== null && _a !== void 0 ? _a : 0) - ((_b = sortIndex === null || sortIndex === void 0 ? void 0 : sortIndex[b]) !== null && _b !== void 0 ? _b : 0); })
                        .map((message) => (_jsx("div", { dangerouslySetInnerHTML: { __html: messages[message] } }, message))) })] }, 'resources-preview-root'),
    ];
};
//# sourceMappingURL=resources.preview.component.js.map